import { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';

export const useResize = (desktopSize = 1023, padSize = 767) => {
  const resizeRef = useRef();

  const [deviceType, setDeviceType] = useState('desktop');

  useEffect(() => {
    const resizeWin = throttle(() => {
      if (window.innerWidth > desktopSize && resizeRef.current !== 'desktop') {
        resizeRef.current = 'desktop';
        setDeviceType('desktop');
      } else if (window.innerWidth > padSize && window.innerWidth <= desktopSize && resizeRef.current !== 'pad') {
        resizeRef.current = 'pad';
        setDeviceType('pad');
      } else if (window.innerWidth <= padSize && resizeRef.current !== 'mobile') {
        resizeRef.current = 'mobile';
        setDeviceType('mobile');
      }
    }, 200);

    resizeWin();
    window.addEventListener('resize', resizeWin);
    return () => window.removeEventListener('resize', resizeWin);
    // only load once
    // eslint-disable-next-line
  }, []);

  return deviceType;
};
